import React from 'react';
import { ChevronsLeftIcon, ChevronsRightIcon } from 'lucide-react';
interface SectionHeadingProps {
  id?: string;
  children: React.ReactNode;
  tone?: 'navy' | 'white';
  className?: string;
}

/** Mirrors the Metro page's «« HEADING »» treatment. */
export function SectionHeading({
  id,
  children,
  tone = 'navy',
  className = ''
}: SectionHeadingProps) {
  const text = tone === 'white' ? 'text-white' : 'text-brand-navy';
  const chev = tone === 'white' ? 'text-sky-200' : 'text-brand-sky';
  return <h2 id={id} className={`flex items-center justify-center gap-3 text-center font-display text-[26px] font-semibold uppercase leading-tight md:text-[32px] ${text} ${className}`} data-id="element-173" data-mp="gjq1fvl64fho">
      <ChevronsLeftIcon className={`h-6 w-6 shrink-0 ${chev}`} aria-hidden="true" data-id="element-174" data-mp="6tdg415j4iah" />
      <span data-id="element-175" data-mp="uj7w2rl5amyy">{children}</span>
      <ChevronsRightIcon className={`h-6 w-6 shrink-0 ${chev}`} aria-hidden="true" data-id="element-176" data-mp="uizfaolwixih" />
    </h2>;
}